import { BaseEntity, Column, Entity, Index, JoinColumn, JoinTable, ManyToMany, ManyToOne, OneToMany, OneToOne, PrimaryColumn, PrimaryGeneratedColumn, RelationId, VersionColumn, UpdateDateColumn, CreateDateColumn } from "typeorm";
import { EndCustomers } from "../end-customer/end-customer.entity";
import { Rack } from "../racks/racks.entity";
import { RmRack } from "../rm-racks/rm-racks.entity";
import { SkuCodes } from "../sku-codes/sku-codes.entity";
import { ZoneMaster } from "../zone-master/zone-master.entity";

@Entity('rack_zone_mapping')
export class RackZoneMapping {

  @PrimaryGeneratedColumn("increment", { name: 'rackzonemappping_id' })
  rackZoneMappingId?: number;

  @Column("int",{
    nullable:false,
    name:"zone_id"
    })
  zoneId:number;
  @Column("int",{
    nullable:false,
    name:"rack_id"
    })
  rackId:number;
  @Column("int",{
    nullable:false,
    name:"end_customer_id"
    })
  endCustomerId:number;
  @Column("boolean", {
    nullable: false,
    name: "isActive",
    default:true
  })
  isActive: boolean | null;

  @CreateDateColumn({
    name: "created_at",
    type: "datetime"
  })
  createdAt: Date;

  @Column("varchar", {
    nullable: false,
    name: "created_user",
    length: 50
  })
  createdUser: string | null;


  @UpdateDateColumn({
    name: "updated_at",
    type: 'datetime'
  })
  updatedAt: Date;

  @Column("varchar", {
    nullable: true,
    name: "updated_user",
    length: 50
  })
  updatedUser: string | null;

  @VersionColumn({
    default: 1,
    name: "version_flag"
  })
  versionFlag: number;
  
  @ManyToOne(type => Rack, rack => rack.rackZoneInfo, { nullable: false, })
  @JoinColumn({ name: "rack_id" })
  rackInfo: Rack;

  @ManyToOne(type =>ZoneMaster , rack => rack.rackZoneInfo, { nullable: false, })
  @JoinColumn({ name: "zone_id" })
  zoneInfo: ZoneMaster;

  @ManyToOne(type =>EndCustomers , rack => rack.rackZoneInfo, { nullable: false, })
  @JoinColumn({ name: "end_customer_id" })
  endCustomerInfo: EndCustomers;
  
  @ManyToOne(type => RmRack, rack => rack.rmRackZoneInfo, { nullable: false, })
  @JoinColumn({ name: "rack_id" })
  rmRackInfo: RmRack;


}
